import { ArrowLeft, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex-1 flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <div className="text-7xl font-bold bg-brand-gradient bg-clip-text text-transparent mb-4">404</div>
        <h1 className="text-2xl font-semibold text-content-primary">Page not found</h1>
        <p className="mt-3 text-content-tertiary">The page you're looking for doesn't exist or has been moved.</p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-4 py-2.5 bg-surface-secondary hover:bg-interactive-active border border-border-secondary rounded-lg text-sm font-medium text-content-primary transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Go Back
          </button>
          <button
            onClick={() => navigate("/dashboard")}
            className="flex items-center gap-2 px-4 py-2.5 bg-brand-gradient text-white rounded-lg text-sm font-medium hover:opacity-90 transition-opacity"
          >
            <Home className="h-4 w-4" />
            Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
